import React from 'react';
import Faqs from '../components/Faqs';

function FaqsPage() {
    return <Faqs />;
}

export default FaqsPage();
